import { ModeEdit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { GridCustomCellProps } from "@progress/kendo-react-grid";

interface Props {
  onEditClick: (data: any) => void;
}

export const EditActionCell = ({
  onEditClick,
  ...props
}: Props & GridCustomCellProps) => {
  return (
    <>
      <td {...props.tdProps}>
        <IconButton onClick={() => onEditClick(props.dataItem)}>
          <ModeEdit />
        </IconButton>
      </td>
    </>
  );
};
